export enum NewFieldVisibility {
    All,
    Feature,
    Division,
    Transaction
}